/**
 * [一般開発者利用不可]
 * メッセージレベル
 */
export enum MessageLevel {
  ERROR = 'error',
  WARN  = 'warn',
  INFO  = 'info'
}
